import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { SlNavBarPositions, SlNavbarThemes } from '../../../features/shared/public/globalInterfaces/globalInterfaces';
import { SlNavbarState } from '../../../features/navigation/private/global-interface';
import { setNavigationConfigs } from '../../utils/navigationManager';
import { SlLanguageLandingPage } from '../../../features/staticPages/public/SlLanguageLandingPage';

export const LanguageLandingPage = () => {
	const { languageAlias } = useParams();

	useEffect(() => {
		setNavigationConfigs({
			state: SlNavbarState.shown,
			theme: SlNavbarThemes.light,
			position: SlNavBarPositions.relative,
		});

		return (() => {
			setNavigationConfigs({
				state: SlNavbarState.hidden,
			});
		});
	}, []);

	return <SlLanguageLandingPage key={languageAlias} />;
};
